export type CreateProjectResponse = {
  pjtId: string;
};
